import { useState, type ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams, useNavigate } from 'react-router-dom'
import { useCase } from '../hooks'
import { CollectionSetProvider } from '../hooks/use-collection-set'
import {
  CaseHeader,
  LoadingState,
  NotFoundState,
  TabContent,
  TabsNav,
} from './case-detail-page/case-detail-page.parts'
import type { TabId } from './case-detail-page/case-detail-page.helpers'

export function CaseDetailPage(): ReactElement {
  const { t } = useTranslation('cases')
  const { caseId } = useParams<{ caseId: string }>()
  const navigate = useNavigate()
  const { caseData, loading, error, refetch } = useCase(caseId ?? null)
  const [activeTab, setActiveTab] = useState<TabId>('overview')

  if (loading) return <LoadingState t={t} />
  if (error || !caseData || !caseId) return <NotFoundState error={error} t={t} />

  return (
    <CollectionSetProvider>
      <div className="min-h-screen" style={{ background: 'var(--bg)' }}>
        <div
          className="border-b"
          style={{ background: 'var(--bg-card)', borderColor: 'var(--border)' }}
        >
          <CaseHeader
            caseData={caseData}
            onBack={() => {
              void navigate('/dashboard')
            }}
            onRefresh={() => {
              void refetch()
            }}
            t={t}
          />
          <TabsNav activeTab={activeTab} onChange={setActiveTab} t={t} />
        </div>
        <div className="p-6">
          <div className="rounded-xl border border-slate-200 bg-white p-6 dark:border-slate-800 dark:bg-slate-900">
            <TabContent activeTab={activeTab} caseId={caseId} caseData={caseData} t={t} />
          </div>
        </div>
      </div>
    </CollectionSetProvider>
  )
}
